/* eslint-disable import/prefer-default-export */
import './src/styles/global.css';
import React from 'react';
import { Authenticator } from '@aws-amplify/ui-react';

export const wrapRootElement = ({ element }) => (
  <Authenticator.Provider>{element}</Authenticator.Provider>
);

export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  const currentPosition = getSavedScrollPosition(location);

  setTimeout(() => {
    window.scrollTo(...(currentPosition || [0, 0]));
  }, 0);

  return false;
};
